import React from "react"
import { ComuneData } from "../../comuni/components/ComuneData";
import { FrazioneData } from "../../comuni/components/FrazioneData";
import { ClienteDto, Comune, Frazione, ImpiantoLight } from "../../generated"
import Store from "../ImpiantiClienteStore";

interface Props {
    id: number | undefined | null;
    idCliente: number | undefined | null;
    template: (item: ImpiantoLight) => JSX.Element | string | number;
}

export const ImpiantoLightDataComponent: React.FC<Props> = ({ id, idCliente, template }) => {
    if (!id || !idCliente)
        return null;
    const impianto = Store.use(idCliente, id);
    if (!impianto) return null;
    return <>{template(impianto)}</>;
}


export const ImpiantoAddressDescription = (props: { customer: ClienteDto, idImpianto: number }) => {
    const { customer, idImpianto } = props;
    const getDescription = (comune: Comune | null, frazione: Frazione | null, indirizzo: string) => {
        const arr: string[] = [];
        if (indirizzo)
            arr.push(indirizzo)
        if (frazione?.nomeFrazione && frazione.nomeFrazione?.toLowerCase() != comune?.nomeComune?.toLowerCase())
            arr.push(frazione.nomeFrazione);
        if (comune?.nomeComune)
            arr.push(comune?.nomeComune);
        if (comune?.provincia)
            arr.push(comune.provincia)
        return arr.join(", ")
    }

    return <ImpiantoLightDataComponent idCliente={customer.idCliente} id={idImpianto}
        template={impianto => {
            const codFisComune = impianto.codFisComune ?? customer.comune?.codFisComune;
            const codFrazione = impianto.codFrazione ?? customer.frazione?.codFrazione;
            const address = impianto.indirizzo ?? customer.indirizzo;
            return <ComuneData codFisComune={codFisComune}
                selector={comune =>
                    <FrazioneData
                        codFisComune={codFisComune}
                        codFrazione={codFrazione}
                        selector={frazione => getDescription(comune, frazione, address ?? "")}
                    />
                }
            />
        }
        }
    />
}
